import { render, staticRenderFns } from "./PreviewCertificateAws.vue?vue&type=template&id=f33ac364&"
import script from "./PreviewCertificateAws.vue?vue&type=script&lang=js&"
export * from "./PreviewCertificateAws.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports